import Authority from "../../../../../util/Authority"
import { Transfer, AlternativeTransfer } from "../../../interfaces"
import { Driver, FormState } from "../interfaces"
import { isAlternativeTransfer, isStandardTransfer } from "../utils/editTransferServiceUtils"

interface UseDriversDataProps {
    itemData: Transfer | AlternativeTransfer
    setForm: React.Dispatch<React.SetStateAction<FormState>>
    setOpenDriverModal: React.Dispatch<React.SetStateAction<boolean>>
    itemSelect: number
}

export const useDriversData = ({itemData, setForm, setOpenDriverModal, itemSelect}: UseDriversDataProps) => {
  const onSaveDriver = (selectedDriver: Driver | null) => {
    setForm((prevState) => ({
      ...prevState,
      driver: selectedDriver,
    }))
    setOpenDriverModal(false)
  }

  const handleDriversModal = (
    e: React.MouseEvent<HTMLButtonElement>,
    value: boolean
  ) => {
    e.preventDefault()
    setOpenDriverModal(value)
  }

  const canAssignDriver = () => {
    const userCompanyId = Authority.getAuthorizedCompanyId()
    if (isStandardTransfer(itemData)) {
      return userCompanyId === itemData.providerId
    }else if (isAlternativeTransfer(itemData)){
      const companyItem = itemData.items.find((item) => item.order === itemSelect)?.companyIdPartnership?.companyId
      return userCompanyId === companyItem
    }
  }

  const formatDriverData = (driver: Driver | {personId: number, lastName: string, firstName: string} | null): Driver | null => {
    if (!driver) return null;
    if ('personId' in driver) {
      return {
        id: driver.personId,
        value: `${driver.lastName} ${driver.firstName}`,
      }
    }
    return driver
  }

  return { onSaveDriver, handleDriversModal, canAssignDriver, formatDriverData }
}
